import { render, staticRenderFns } from "./BookingFormPrescriber.vue?vue&type=template&id=583e13f2&scoped=true&"
import script from "./BookingFormPrescriber.vue?vue&type=script&lang=ts&"
export * from "./BookingFormPrescriber.vue?vue&type=script&lang=ts&"
import style0 from "./BookingFormPrescriber.vue?vue&type=style&index=0&id=583e13f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583e13f2",
  null
  
)

export default component.exports